import gql from 'graphql-tag';
import { Mutation } from 'core/index';
import { Subscription } from 'core/subscription';

export const CONVERT_ASSEMBLY_MUTATION = gql`
  mutation ConvertAssembly($cadConvertInput: CadConvertInput!) {
    cadConvert(input: $cadConvertInput) {
      id
      status
      error
      format
      url
      cadId
    }
  }
`;

export class ConvertAssemblyMutation extends Mutation {
  static conf = {
    GQL: CONVERT_ASSEMBLY_MUTATION,
    inputName: 'cadConvertInput',
    resultPath: 'cadConvert',
  };
}

export const EXTRACT_PART_MUTATION = gql`
  mutation extractParts($extractPartsInput: ExtractPartsInput!, $spaceId: ID) {
    extractParts(input: $extractPartsInput, spaceId: $spaceId) {
      id
      jobSpec {
        build {
          id
          body {
            cadId
            status
            error
            srcFile {
              id
            }
          }
        }
      }
    }
  }
`;

export class ExtractPartMutation extends Mutation {
  static conf = {
    GQL: EXTRACT_PART_MUTATION,
    inputName: ['extractPartsInput', 'spaceId'],
    resultPath: 'extractParts',
  };
}

const CAD_CONVERSION_SUBSCRIPTION = gql`
  subscription CadConversionSubscription(
    $subscribeCADConversionInput: SubscribeCadConversionInput!
  ) {
    cadConversion(input: $subscribeCADConversionInput) {
      status
      error
      format
      url
      cadId
      size
    }
  }
`;

export class CADConversionSubscription extends Subscription {
  static conf = {
    GQL: CAD_CONVERSION_SUBSCRIPTION,
    resultPath: 'cadConversion',
  };
}

const PART_EXTRACTION_SUBSCRIPTION = gql`
  subscription PartExtractionSubscription(
    $subscribePartExtractionInput: SubscribePartExtractionInput!
  ) {
    partExtraction(input: $subscribePartExtractionInput) {
      status
      error
      url
      cadId
      size
    }
  }
`;

export class PartExtractionSubscription extends Subscription {
  static conf = {
    GQL: PART_EXTRACTION_SUBSCRIPTION,
    resultPath: 'partExtraction',
  };
}
